<% include('../common/carousel.art', {style: style, basic: basic, content: content, id: id, type: type, terminal: '', terminalTitle: '', isDesign: isDesign}) %>